import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import MainTemplate from "../../../mainTemplate/";
import CheckBox from "canvas-core-react/lib/Checkbox";
import * as instanceActions from "../../../../../Redux/api";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import * as UserActions from "../../../../../Redux/actions/userActions";
import Provider from "../../../../../../static/images/user-add-grey.svg";
import { useTranslation } from "react-i18next";
import Modal from "../../../../utils/customModal";
import {
  errorContainer,
  loadingHtml,
  sucessInfoModal,
  invalidPhoneNumber,
  includeSpecialCharacters,
  invalidPhoneLastCharacter,
} from "../../../../utils/functions";
import AddUserForm from "../AddUserForm";
import { useDispatch } from "react-redux";

const options = [
  {
    name: "firstName",
    validation: includeSpecialCharacters,
    msg: "includeSpecialCharacters",
  },
  {
    name: "lastName",
    validation: includeSpecialCharacters,
    msg: "includeSpecialCharacters",
  },
  {
    name: "phone",
    validation: invalidPhoneNumber,
    msg: "invalidPhoneNumber",
  },
  {
    name: "phone",
    validation: invalidPhoneLastCharacter,
    msg: "invalidPhoneLastCharacter",
  },
];

const getDefaulttProvider = () => ({
  firstName: "",
  lastName: "",
  id: "",
  phone: "",
  email: "",
});

const UserForm = () => {
  const [state, setState] = useState({
    provider: getDefaulttProvider(),
    modulo: [],
    contentReady: false,
    checkedModule: [],
    check: false,
    errors: {},
    submitted: false,
  });

  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
    showClose: false,
  });

  const { institutionId, providerId, companyId, id, country } = useParams();

  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const getInitialData = async () => {
    try {
      const response = await dispatch(
        UserActions.getUserDefaultModules(institutionId)
      );

      setState((prev) => ({
        ...prev,
        modulo: response.data,
        contentReady: true,
      }));
    } catch (error) {
      console.log(error);
    }
    setModal((prev) => ({ ...prev, show: false }));
  };

  useEffect(() => {
    setModal((prev) => ({ ...prev, show: true }));
    getInitialData();

    return () =>
      setState((prev) => ({ ...prev, contentReady: false, modulo: [] }));
  }, []);

  const moduleHandlerChange = (event) => {
    const { checkedModule } = state;
    const [moduleId, permissionId] = event.target.name.split("-");

    if (
      checkedModule[`mod-${moduleId}`] !== undefined &&
      checkedModule[`mod-${moduleId}`][event.target.name] !== undefined &&
      !event.target.checked
    ) {
      let mod = checkedModule[`mod-${moduleId}`];
      delete mod[event.target.name];
      checkedModule[`mod-${moduleId}`] = mod;

      //Limpiamos si no quedan más permisos para este modulo
      if (Object.keys(checkedModule[`mod-${moduleId}`]).length <= 0) {
        delete checkedModule[`mod-${moduleId}`];
      }
    } else if (event.target.checked === true) {
      if (checkedModule[`mod-${moduleId}`] === undefined) {
        checkedModule[`mod-${moduleId}`] = [];
      }
      checkedModule[`mod-${moduleId}`][event.target.name] = {
        id: permissionId,
      };
    }

    setState((prev) => ({ ...prev, checkedModule }));
  };

  const clearState = () => {
    setState((prev) => ({
      ...prev,
      provider: getDefaulttProvider(),
      checkedModule: [],
      check: false,
    }));
  };

  const getUserData = () => {
    const { provider, checkedModule } = state;
    let modules = [];
    Object.keys(checkedModule).map((key) => {
      let permissions = [];

      Object.keys(checkedModule[key]).map((kp) =>
        permissions.push({
          id: parseInt(checkedModule[key][kp].id, 10),
          assigned: true,
        })
      );

      return modules.push({ id: key.split("-")[1], permissions });
    });
    return {
      data: {
        email: provider.email,
        firstName: provider.firstName,
        identification: provider.id,
        lastName: provider.lastName,
        phone: provider.phone,
        modules,
      },
    };
  };

  const closeStep = () => {
    history.push(
      `/bscadministrator/providers/${providerId}/${companyId}/profile`
    );
  };

  const closeModal = () => {
    setModal((prev) => ({
      ...prev,
      show: false,
      type: "loading",
      onClose: undefined,
      modalMessage: { title: "", message: "" },
    }));
    clearState();
    closeStep();
  };

  const finishAdmission = () => {
    const buttons = {
      SelBtn: {
        text: "Continuar",
        action: closeModal,
      },
    };

    const content = sucessInfoModal(
      "Estimado usuario",
      `La operación fue realizada con éxito`,
      buttons
    );

    setModal({
      content,
      show: true,
      showClose: true,
      onClose: closeModal,
    });
  };

  const handlerChange = (event) => {
    event?.persist && event?.persist();
    const { value, name } = event.target;
    const { provider } = state;

    provider[name] = value;

    setState((prev) => ({
      ...prev,
      provider,
      errors: state.submitted ? handleErrors(provider) : {},
    }));
  };

  const handleErrors = (provider) => {
    return options.reduce((acc, { name, validation, msg }) => {
      if (validation(provider[name])) {
        if (!acc[name]) acc[name] = t(`general.formErrors.${msg}`);
      }
      return acc;
    }, {});
  };

  const createProviderUser = async (event) => {
    event.preventDefault();

    const data = getUserData();
    const errors = handleErrors(data.data);
    setState((prev) => ({ ...prev, errors, submitted: true }));

    if (Object.keys(errors).length) return;

    setModal((prev) => ({ ...prev, content: loadingHtml(), show: true }));

    try {
      await dispatch(
        instanceActions.instanceAction(
          `users/provider/${id}/${country}`,
          "put",
          data
        )
      );

      finishAdmission();
    } catch (err) {
      let content = "";
      if (
        err.response !== undefined &&
        Array.isArray(err.response.data.notifications)
      ) {
        const notification = err.response.data.notifications[0];
        content = errorContainer(
          notification.message,
          notification.description,
          { cancelBtn: { text: "Cerrar", action: () => closeModal() } }
        );
      }

      setModal((prev) => ({ ...prev, content, onClose: closeModal }));
      closeModal();
    }
  };

  const { provider, contentReady, modulo, checkedModule, errors } = state;

  const disabled =
    Object.keys(provider).some((key) => !provider[key].trim()) ||
    !Object.keys(checkedModule).length;

  return (
    <MainTemplate>
      {contentReady && (
        <div id="user-provider">
          <div className="header-title flex-element">
            <div className="title gest-client flex-element">
              <img src={Provider} />
              <p className="client-gest">Agregar Usuario</p>
            </div>
          </div>

          <AddUserForm
            firstName={provider.firstName}
            lastName={provider.lastName}
            identification={provider.id}
            phone={provider.phone}
            status="Pendiente de Aprobación"
            handlerChange={handlerChange}
            readOnly={false}
            pendingData={null}
            email={provider.email}
            isAddUser={false}
            errors={errors}
          />

          <div className="clearfix pt-5">
            {modulo.map((mod, key) => (
              <div key={`${mod.id}-${key}`} className="loaded-module-user">
                <div className="flex-element">
                  <p>{mod.displayName}</p>
                </div>
                <div className="roles">
                  {mod.permissions.map((permission, moduleKey) => (
                    <CheckBox
                      key={`${moduleKey}-${permission.code}-${permission.code}`}
                      id={`${permission.id}-${permission.id}`}
                      name={`${mod.id}-${permission.id}`}
                      label={permission.displayName}
                      checked={
                        checkedModule[`mod-${mod.id}`] !== undefined &&
                        checkedModule[`mod-${mod.id}`][
                          `${mod.id}-${permission.id}`
                        ] !== undefined
                      }
                      disabled={permission.code === "S"}
                      onChange={(event) => moduleHandlerChange(event)}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="form-actions clearfix">
            <SecondaryButton className="btnLimpiar" onClick={history.goBack}>
              {t("general.buttons.cancel")}
            </SecondaryButton>
            <SecondaryButton
              id="saveProvider"
              className="btnAgregar"
              disabled={disabled}
              onClick={(event) => createProviderUser(event)}
            >
              {t("general.buttons.save")}
            </SecondaryButton>
          </div>
        </div>
      )}

      <Modal
        show={modal.show}
        handleClose={modal.onClose}
        showClose={modal.showClose}
      >
        {modal.content}
      </Modal>
    </MainTemplate>
  );
};

export default UserForm;
